var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoBgRemover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_10350_82308"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_10350_82308)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.25,1.25L2,1.25Q1.27513,1.25,0.762564,1.76256Q0.25,2.27513,0.25,3L0.25,13Q0.25,13.7249,0.762564,14.2374Q1.27513,14.75,2,14.75L7.25,14.75L7.25,15.25C7.25,15.6642,7.58579,16,8,16C8.41421,16,8.75,15.6642,8.75,15.25L8.75,14.75L14,14.75Q14.7249,14.75,15.2374,14.2374Q15.75,13.7249,15.75,13L15.75,3Q15.75,2.27513,15.2374,1.76256Q14.7249,1.25,14,1.25L8.75,1.25L8.75,0.75C8.75,0.335786,8.41421,0,8,0C7.58579,0,7.25,0.335786,7.25,0.75L7.25,1.25ZM7.25,2.75L7.25,4.00691Q7.43525,4.07692,7.62049,4.18387L8.75,4.836L8.75,2.75L10.9255,2.75L8.80674,4.86875L10.1516,5.64521L13.0468,2.75L14,2.75Q14.25,2.75,14.25,3L14.25,4.06471L11.4442,6.87048Q11.5977,7.25033,11.5977,7.71875Q11.5977,8.95742,10.5249,9.57675L7.62049,11.2536Q7.43524,11.3606,7.25,11.4306L7.25,13.25L2,13.25Q1.75,13.25,1.75,13L1.75,3Q1.75,2.75,2,2.75L7.25,2.75ZM5.90234,9.3956L5.90234,6.04184C5.90234,5.54499,6.4402,5.23445,6.87049,5.48288L9.77493,7.15976C10.20522,7.40819,10.20522,8.02926,9.77493,8.27768L8.75,8.86943L8.75,8.86946L7.25,9.73549L7.25,9.73545L6.87049,9.95456C6.4402,10.203,5.90234,9.89246,5.90234,9.3956ZM8.75,13.25L9.75098,13.25L14.25,8.75083L14.25,6.18604L8.75,11.686L8.75,13.25ZM14.25,10.8722L11.8723,13.25L14,13.25Q14.25,13.25,14.25,13L14.25,10.8722Z",
    fillRule: "evenodd",
    fill: "#414751",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBgRemover);
export default __webpack_public_path__ + "static/media/video-bg-remover.d499cc68b3845d55b5dd51b46adc001f.svg";
export { ForwardRef as ReactComponent };